// libs
import React, { useEffect } from 'react'

// components
import Logo from 'src/components/logo/logo'
import withPortal from 'src/high_order_components/with_portal'

// helpers
import { CLASS_PREFIX } from 'src/constants/'
import './authentication_modal.scss'

const cls = `${CLASS_PREFIX}authentication_modal`
const BODY_CLASS = `${CLASS_PREFIX}body--modal-open`

interface IProps {
  children?: React.ReactNode;
  onClose?: () => void;
}

export const AuthenticationModal = withPortal(({ children, onClose }: IProps) => {
  useEffect(() => {
    document.body.classList.add(BODY_CLASS)
    return () => {
      document.body.classList.remove(BODY_CLASS)
    }
  }, [])

  return (
    <div className={cls}>
      <div className={`${cls}__backdrop`} onClick={onClose} />
      <div className={`${cls}__logo`}>
        <Logo type="HORIZONTAL" altText="Lokalportal" />
      </div>
      <div className={`${cls}__surface`}>{children}</div>
    </div>
  )
})
